import { joinPath } from '@eventbrite/path-utils';
import { push } from 'react-router-redux';

import { getEventsData, getEventsWithDowngradeConflicts } from '../api';
import { _trackEventActionsAU, setPackageOne } from './changePlan';
import { GA_PACKAGE_DOWNGRADED } from '../constants/analytics';
import {
    DEFAULT_PAGE_NUMBER,
    PACKAGE_ONE_QUERY_STRING,
} from '../constants/downgrade';
import {
    BASE_URL,
    CHANGE_PLAN_DOWNGRADE_CONFLICTS_PATH,
    CHANGE_PLAN_DOWNGRADE_PATH,
} from '../constants/main';

export const hasDowngradeConflicts = (conflictsApiResponse) => {
    const { objectCount } = conflictsApiResponse.pagination;
    return !!objectCount;
};

export const assembleConflictsData = ({ conflicts, events }) => {
    const { downgradeConflicts } = conflicts;
    const conflictsWithExpandedEvents = downgradeConflicts.reduce(
        (acc, { eventId, downgradeConflicts }) => [
            ...acc,
            {
                downgradeConflicts,
                event: events.find((e) => e.id === eventId),
            },
        ],
        [],
    );
    return { ...conflicts, downgradeConflicts: conflictsWithExpandedEvents };
};

export const STORE_CONFLICTS = 'STORE_CONFLICTS';
export const IS_FETCHING = 'IS_FETCHING';

export const storeConflicts = (payload) => ({
    type: STORE_CONFLICTS,
    payload,
});

export const isFetching = (payload = true) => ({
    type: IS_FETCHING,
    payload,
});

export const checkConflicts = () => async (dispatch, getState) => {
    const state = getState();
    const {
        user: { activeScopeUserId },
    } = state;
    const eventsWithDowngradeConflicts = await getEventsWithDowngradeConflicts({
        organizationId: activeScopeUserId,
        desiredPackage: PACKAGE_ONE_QUERY_STRING,
    });

    if (hasDowngradeConflicts(eventsWithDowngradeConflicts)) {
        const eventIds = eventsWithDowngradeConflicts.downgradeConflicts.map(
            (item) => item.eventId,
        );
        const { events } = await getEventsData(eventIds);
        dispatch(
            storeConflicts(
                assembleConflictsData({
                    events,
                    conflicts: eventsWithDowngradeConflicts,
                }),
            ),
        );
        dispatch(
            push(
                joinPath(
                    BASE_URL,
                    CHANGE_PLAN_DOWNGRADE_PATH,
                    CHANGE_PLAN_DOWNGRADE_CONFLICTS_PATH,
                ),
            ),
        );
    } else {
        dispatch(_trackEventActionsAU(GA_PACKAGE_DOWNGRADED));
        dispatch(setPackageOne());
    }
};

export const getConflictsPayload = async (
    organizationId,
    desiredPackage,
    pageNumber,
) => {
    const response = await getEventsWithDowngradeConflicts({
        organizationId,
        desiredPackage,
        pageNumber,
    });
    const eventIds = response.downgradeConflicts.map((item) => item.eventId);
    const { events } = await getEventsData(eventIds);

    return assembleConflictsData({ events, conflicts: response });
};

export const fetchConflicts =
    (pageNumber = DEFAULT_PAGE_NUMBER) =>
    async (dispatch, getState) => {
        const {
            user: { activeScopeUserId },
        } = getState();

        dispatch(isFetching(true));
        const payload = await getConflictsPayload(
            activeScopeUserId,
            PACKAGE_ONE_QUERY_STRING,
            pageNumber,
        );

        dispatch(isFetching(false));
        dispatch(storeConflicts(payload));
        return {
            ...payload,
            downgradeConflicts: {
                0: payload.downgradeConflicts,
            },
        };
    };
